<!--
 * @Author: your name
 * @Date: 2020-07-29 11:51:28
 * @LastEditTime: 2020-07-29 18:37:39
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/lib/ui/components/form/form-money-input/form-money-input.vue
-->
<template>
  <div class="form-money-input form-item">
    <x-proxy-form-item
    :showRequired="showRequired"
    :label="widget.label"
    :processTitle="widget.processTitle"
    :validatorRules="validatorRules"
    :validateKey="validateKey"
    :validateInfo="validateInfo"
    :disabled="disabled">
      <x-input-money
        v-if="renderSence === 'edit'"
        v-model="formValue"
        :disabled="disabled"
        :placeholder="placeholder"
        :tabindex="tabindex"
        :displayType="widget.moneyDisplayStyle === 'TEXT' ? 'zh-CN' : 'normal' "
      ></x-input-money>
      <x-input-money
        v-if="renderSence === 'read'"
        v-model="formValue"
        :renderSence="renderSence"
        :displayType="widget.moneyDisplayStyle === 'TEXT' ? 'zh-CN' : 'normal' "
      ></x-input-money>
    </x-proxy-form-item>
  </div>
</template>

<script>
import FormWidgetConfigMixin from '../../../mixins/form-widget.mixin'
import XInputMoney from '../../x-input-money/x-input-money'
import WidgetRangeValidator from '../../../form-validator/widget-range-validator'

export default {
  name: 'FormMoneyInput',
  mixins: [FormWidgetConfigMixin],
  components: {
    XInputMoney
  },
  watch: {
    'widget.numberMin': {
      handler(newValue, oldValue) {
        this.widgetRules = [
          this._validate(WidgetRangeValidator(newValue, this.widget.numberMax, `金额`))
        ]
      },
      immediate: true
    },
    'widget.numberMax': {
      handler(newValue, oldValue) {
        this.widgetRules = [
          this._validate(WidgetRangeValidator(this.widget.numberMin, newValue, `金额`))
        ]
      },
      immediate: true
    }
  },
  computed: {
    placeholder() {
      return this.widget.enableRule 
        ? '自动计算'
        : this.widget.readOnly 
          ? '' 
          : this.widget.placeholder
    },
    disabled() {
      return this.widget.enableRule || this.widget.readOnly
    }
  }
}
</script>

<style lang="scss">
.form-money-input {}
</style>